import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import {ActionItem, ActionMenu} from "@khanacademy/wonder-blocks-dropdown";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import IconButton from "@khanacademy/wonder-blocks-icon-button";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {ImageSource} from "@khan/guide-types";

import camera from "@phosphor-icons/core/regular/camera.svg";
import images from "@phosphor-icons/core/regular/images.svg";
import link from "@phosphor-icons/core/regular/link.svg";
import paperclip from "@phosphor-icons/core/regular/paperclip.svg";

interface Props {
    // Callback to open the modal for the selected image source.
    onOpenModal: (imageSource: ImageSource) => void;
}

// Map of image sources to their corresponding icons.
const icons = {
    [ImageSource.ProvidedByFile]: images,
    [ImageSource.ProvidedByCamera]: camera,
    [ImageSource.ProvidedByURL]: link,
};

/**
 * A dropdown menu for selecting the image input mode (file upload, camera, or URL).
 */
export const InputModeMenu = ({onOpenModal}: Props) => {
    const label = t`Select an image input mode`;
    const options = [
        {label: t`Images`, value: ImageSource.ProvidedByFile},
        {label: t`Camera`, value: ImageSource.ProvidedByCamera},
        {label: t`From URL`, value: ImageSource.ProvidedByURL},
    ];

    return (
        <ActionMenu
            // Move the menu above the tooltip.
            dropdownStyle={{transform: "translateY(-64px)"}}
            key={label}
            aria-label={label}
            menuText=""
            opener={() => (
                <IconButton
                    size="small"
                    style={styles.attachButton}
                    kind="tertiary"
                    icon={paperclip}
                    aria-label={label}
                    testId="image-attach-button"
                />
            )}
        >
            {options.map(({label, value}) => (
                <ActionItem
                    key={value}
                    label={label}
                    leftAccessory={
                        <PhosphorIcon size="medium" icon={icons[value]} />
                    }
                    onClick={() => onOpenModal(value)}
                />
            ))}
        </ActionMenu>
    );
};

const styles = StyleSheet.create({
    attachButton: {
        color: color.offBlack64,
        ":hover": {
            color: color.offBlack64,
            borderColor: color.offBlack64,
        },
    },
});
